import { render, staticRenderFns } from "./UsecaseExit.vue?vue&type=template&id=fb7483d6"
import script from "./UsecaseExit.vue?vue&type=script&lang=js"
export * from "./UsecaseExit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports